import React from 'react';
import { Pagination } from 'antd';
class CustomerPage extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            pageMeta: this.props.data
        };
    }

    // 点击下标改变页面
    onPageChange = (page, pageSize) => {
        this.props.onChange(page, pageSize);
    }
    // 列表显示最多条数
    onShowSizeChange = (current, pageSize) => {
       this.props.onChange(current, pageSize);
    }
    componentWillReceiveProps(nextProps: any) {
        if (nextProps.data !== this.props.data) {
            this.setState({
                pageMeta: nextProps.data,
            });
        }
    }
    render() {
        const { pageMeta } = this.state;
        const isShowPageSize = this.props.showSizeChanger !== undefined ?  this.props.showSizeChanger : true; 
        return (
            <div className="my-pagination"  style={{ 'padding': '16px 10px 16px', 'position': 'relative', textAlign: 'center' , fontSize: '14px'}}>
                <Pagination
                    size="small"
                    showQuickJumper={true}
                    defaultCurrent={pageMeta.pageNum}

                    total={pageMeta.total}
                    current={pageMeta.pageNum}
                    pageSize={pageMeta.pageSize}
                    pageSizeOptions={this.props.pageSizeOptions || []}
                    showTotal={(total, range) => {
                        if (total > 0) {
                            return (
                            <span>
                                {!this.props.hideTotal && 
                                    <span>
                                        第 {(pageMeta.pageNum - 1) * pageMeta.pageSize + 1} - {pageMeta.pageNum * pageMeta.pageSize} 条，共有
                                        <span className="number">{total}</span>
                                         条
                                    </span>
                                }
                            </span>);
                        }
                        return '';
                    }}
                    onChange={this.onPageChange}
                    onShowSizeChange={this.onShowSizeChange}
                    showSizeChanger={pageMeta.total  > 0 && isShowPageSize === true ? true : false}
                />
            </div>
        );
    }
}
export default CustomerPage;



// WEBPACK FOOTER //
// ./src/display/components/PageUi.tsx